module.exports = __webpack_public_path__ + "static/img/12.0562254.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/12.png
// module id = cIAD
// module chunks = 0